import {createTypes} from 'redux-action-creator'

export default createTypes(
  [
    'SET_TAB',
  ],
  'SHARED/WITH_ME/',
)



// WEBPACK FOOTER //
// ./src/sections/shared/types/shared.js